module.exports = __webpack_public_path__ + "img/gdRegistration.8ef5c841.png";